import * as React from 'react'
import Avatar, { AvatarProps as MuiAvatarProps } from '@mui/material/Avatar'
import palette from 'core-system/Themes/palette'

const colorsToChooseFrom = [
  palette.secondary.purple400,
  palette.secondary.purple500,
  palette.secondary.purple600,
  palette.secondary.purple700,
  palette.secondary.purple800,
  palette.primary.pink400,
  palette.primary.pink500,
  palette.primary.pink600,
  palette.primary.pink700,
  palette.primary.pink800,
  palette.accent.teal500,
  palette.accent.teal600,
  palette.accent.teal700,
  palette.accent.blue500,
  palette.accent.blue600,
  palette.accent.blue700,
]

const stringToColor = (string: string) => {
  try {
    if (!string) {
      return colorsToChooseFrom[0]
    }

    const hash = string.split('').reduce((acc, char) => {
      return acc + char.charCodeAt(0)
    }, 0)

    const color = colorsToChooseFrom[hash % colorsToChooseFrom.length]

    return color
  } catch (error) {
    return colorsToChooseFrom[0]
  }
}

const sizeToSx = (size: 'small' | 'medium' | 'large' | 'xlarge') => {
  switch (size) {
    case 'small':
      return { width: 32, height: 32, fontSize: 12 }
    case 'medium':
      return { width: 40, height: 40, fontSize: 16 }
    case 'large':
      return { width: 48, height: 48, fontSize: 20 }
    case 'xlarge':
      return { width: 80, height: 80, fontSize: 24 }
  }
}

interface AvatarProps extends MuiAvatarProps {
  name?: string
  type?: 'text' | 'image'
  src?: string
  size?: 'small' | 'medium' | 'large' | 'xlarge'
}

const AvatarView = ({
  name,
  type = 'text',
  src,
  size = 'medium',
  ...props
}: AvatarProps) => {
  const nameInitials = () => {
    try {
      if (!name) {
        return ''
      }
      if (name.split(' ').length === 1) {
        return name.split(' ')[0][0].toUpperCase()
      }
      return (
        name.split(' ')[0][0].toUpperCase() +
        name.split(' ')[1][0].toUpperCase()
      )
    } catch (error) {
      return ''
    }
  }

  if (type === 'text') {
    return (
      <Avatar
        sx={{
          bgcolor: stringToColor(name),
          ...sizeToSx(size),
        }}
      >
        {nameInitials()}
      </Avatar>
    )
  }

  return <Avatar src={src} {...sizeToSx(size)} {...props} />
}

export default AvatarView
